import React from 'react';

import {
  rem,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Grid,
  Box,
  Flex,
  Header,
  Text,
  Image,
} from '@vimeo/bokeh';
import { useIsMobile } from '@vimeo/core/hooks/use-is-mobile';

import DismissIcon from './DismissIcon';
import translations from '../../utils/translations';

interface Props {
  headerText?: string;
  subHeaderText?: string;
  body?: React.ReactNode;
  imgSrc?: string;
  footer?: React.ReactNode;
  onClose: VoidFunction;
  dataTestId?: string;
}

const ImageModal = (props: Props) => {
  const { headerText, subHeaderText, body, footer, imgSrc, dataTestId, onClose } = props;
  const isMobile = useIsMobile();

  const imageLoaded = () => {
    window.dispatchEvent(new Event('resize'));
  };

  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent data-testid={dataTestId} maxW={'fit-content'} height={rem(625)}>
        <DismissIcon onClose={onClose} />
        <ModalBody padding={0}>
          <Grid templateColumns={`${rem(320)} 1fr`} height={'100%'} overflow={'hidden'}>
            <Flex padding={'6'} flexDirection={'column'} justifyContent={'space-between'}>
              <Flex gap={rem('24')} flexDirection={'column'}>
                <Header size="lg">
                  {headerText !== undefined ? headerText : translations.defaultHeader}
                </Header>
                {!!subHeaderText && (
                  <Text variant="body-md">
                    {subHeaderText !== undefined ? subHeaderText : translations.defaultSubHeader}
                  </Text>
                )}
                {body}
              </Flex>
              <Box>{footer}</Box>
            </Flex>
            {imgSrc && !isMobile && (
              <Image
                src={imgSrc}
                alt=""
                onLoad={imageLoaded}
                aspectRatio={'9 / 16'}
                maxWidth={rem(384)}
                height={rem(625)}
                borderRadius={`0 ${rem(20)} ${rem(20)} 0`}
              />
            )}
          </Grid>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ImageModal;
